<template>
    <div>
        <h3>优化(文生图)页面访问量分析</h3>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>日访问量</span>

                <el-date-picker
                    v-model="periodDay"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :picker-options="dayPickerOptions"
                    @change="handleChange('dayly', $event)"
                >
                </el-date-picker>
            </div>
            <div>
                <ve-bar-chart
                    :data="dayData"
                    :settings="chartSettings"
                    :loading="dayLoad"
                    v-bind="options"
                />
            </div>
        </el-card>

        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>周访问量</span>

                <el-date-picker
                    v-model="periodWeek"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :picker-options="weekPickerOptions"
                    @change="handleChange('weekly', $event)"
                >
                </el-date-picker>
            </div>
            <div>
                <ve-bar-chart
                    :data="weekData"
                    :settings="chartSettings"
                    :loading="weekLoad"
                    v-bind="options"
                />
            </div>
        </el-card>

        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>月访问量</span>

                <el-date-picker
                    v-model="periodMonth"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份"
                    :clearable="false"
                    :picker-options="monthPickerOptions"
                    @change="handleChange('monthly', $event)"
                >
                </el-date-picker>
            </div>
            <div>
                <ve-bar-chart
                    :data="monthData"
                    :settings="chartSettings"
                    :loading="monthLoad"
                    v-bind="options"
                />
            </div>
        </el-card>
    </div>
</template>

<script>
import Server from "../../../server";
export default {
    name: "optimize-views-analytics",
    data() {
        return {
            dayPickerOptions: {
                disabledDate: this.disabledDate,
                shortcuts: [
                    this.createShortcut("今天", 0),
                    this.createShortcut("昨天", 1),
                    this.createShortcut("最近7天", 7),
                    this.createShortcut("最近半月", 15),
                ],
            },
            weekPickerOptions: {
                disabledDate: this.disabledDate,
                shortcuts: [
                    this.createShortcut("最近一周", 7),
                    this.createShortcut("最近四周", 30),
                    this.createShortcut("最近十二周", 90),
                ],
            },
            monthPickerOptions: {
                disabledDate: this.disabledDate,
                shortcuts: [
                    this.createShortcut("本月", 0),
                    this.createShortcut("上个月", 30),
                    this.createShortcut("最近六个月", 180),
                ],
            },
            chartSettings: {
                label: {
                    show: true,
                    fontSize: "12",
                    fontWeight: "bold",
                    position: "inside",
                },
                stack: {
                    sum: ["新用户", "老用户"],
                },
            },
            options: {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                    },
                    textStyle: {
                        color: "#fff",
                    },
                    formatter: function (params) {
                        return (
                            params[0].value[0] +
                            "<br/><span class='test' style='background: " +
                            params[0].color +
                            ";'></span>" +
                            params[0].seriesName +
                            " " +
                            params[0].data[1] +
                            "<br/><span class='test' style='background: " +
                            params[1].color +
                            ";'></span>" +
                            params[1].seriesName +
                            " " +
                            params[1].data[2] +
                            "<br/><span class='test' style='background: #ffd600;'></span>总用户 " +
                            (Number(params[0].data[1]) +
                                Number(params[1].data[2]))
                        );
                    },
                },
            },
            periodDay: this.periodDate(15),
            periodWeek: this.periodDate(60),
            periodMonth: this.periodDate(180, "YYYY-MM"),
            dayData: null,
            weekData: null,
            monthData: null,
            dayLoad: true,
            weekLoad: true,
            monthLoad: true,
        };
    },
    mounted() {
        this.initData(this.periodDay, "dayly");
        this.initData(this.periodWeek, "weekly");
        this.initData(this.periodMonth, "monthly");
    },
    methods: {
        periodDate(offsetInDays, format) {
            const end = new Date();
            const start = new Date();
            start.setDate(end.getDate() - offsetInDays);
            return [
                this.$Met.formatDate(start, format),
                this.$Met.formatDate(end, format),
            ];
        },
        disabledDate(time) {
            return time.getTime() > Date.now();
        },
        getStartAndEndDates(offsetInDays) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * offsetInDays);
            return [start, end];
        },
        createShortcut(text, offsetInDays) {
            return {
                text: text,
                onClick: (picker) => {
                    picker.$emit(
                        "pick",
                        this.getStartAndEndDates(offsetInDays)
                    );
                },
            };
        },
        async initData(period, time_dimension) {
            try {
                const params = {
                    start_date: period[0],
                    end_date: period[1],
                    behavior: "view_optimize_image_page",
                    time_dimension,
                };
                const { data } = await Server.get_views_count(params);
                console.log("day data--->", data);
                if (data.code !== 0) throw new Error(data.error);
                let chartData = null;
                if (data.data.length > 0) {
                    const _sortData = data.data.sort((a, b) => {
                        const timestampA = this.$Met.convertToTimestamp(
                            a.time,
                            time_dimension
                        );
                        const timestampB = this.$Met.convertToTimestamp(
                            b.time,
                            time_dimension
                        );
                        return timestampA - timestampB;
                    });
                    chartData = this.processData(_sortData, time_dimension);
                }
                this.updateChartData(time_dimension, chartData);
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: "error",
                });
            } finally {
                this.dayLoad = false;
                this.weekLoad = false;
                this.monthLoad = false;
            }
        },
        processData(data, time_dimension) {
            const result = data.reduce(
                (acc, item) => {
                    if (time_dimension === "weekly") {
                        const [year, week] = item.time.split("-").map(Number);
                        const startDate = this.$Met.startDateFromWeek(
                            year,
                            week
                        );
                        acc.times.push(startDate.toISOString().split("T")[0]);
                    } else {
                        acc.times.push(item.time);
                    }
                    let newUsersCount = 0;
                    let oldUsersCount = 0;

                    item.users.forEach((_d) => {
                        const _timeFlag = this.isSameTime(
                            item.time,
                            _d.register_date,
                            time_dimension
                        );

                        if (_timeFlag) {
                            newUsersCount++;
                        } else {
                            oldUsersCount++;
                        }
                    });

                    acc.newUsers.push(newUsersCount);
                    acc.oldUsers.push(oldUsersCount);
                    // acc.totalUsers.push(item.total_user);
                    return acc;
                },
                {
                    times: [],
                    newUsers: [],
                    oldUsers: [],
                    // totalUsers: [],
                }
            );

            return {
                dimensions: {
                    name: "Date",
                    data: result.times,
                },
                measures: [
                    {
                        name: "新用户",
                        data: result.newUsers,
                    },
                    {
                        name: "老用户",
                        data: result.oldUsers,
                    },
                    // {
                    //     name: "总用户",
                    //     data: result.totalUsers,
                    // },
                ],
            };
        },
        isSameTime(time1, time2, timeDimension) {
            if (timeDimension === "dayly") {
                return time1 === this.$moment(time2).utc().format("YYYY-MM-DD");
            } else if (timeDimension === "weekly") {
                return time1 === this.$moment(time2).utc().format("YYYY-ww");
            } else if (timeDimension === "monthly") {
                return time1 === this.$moment(time2).utc().format("YYYY-MM");
            }
        },
        updateChartData(time_dimension, chartData) {
            const dataMapping = {
                dayly: "dayData",
                weekly: "weekData",
                monthly: "monthData",
            };
            this[dataMapping[time_dimension]] = chartData;
        },
        handleChange(timeDimension, dateRange) {
            console.log("change--->", timeDimension, dateRange);
            const loadMapping = {
                dayly: "dayLoad",
                weekly: "weekLoad",
                monthly: "monthLoad",
            };
            this[loadMapping[timeDimension]] = true;
            this.initData(dateRange, timeDimension);
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.box-card {
    margin-bottom: 70px;
}
</style>
